(ns teamoesterreich.admin-mode.event-alarm.detail.alarm-user-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.data.eventAlarm :as d-eventAlarm]
            [teamoesterreich.admin-mode.modal.send-message-modal :as send-message-modal]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.modal.enter-amount-modal :as enter-amount-modal]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.util.helper :as h]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            [reagent-material-ui.icons.check-box-outline-blank :refer [check-box-outline-blank]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.info :refer [info]]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            ))



(defn count-true [map_]
  (count (filter second map_)))

(defn info-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label   "bearbeiten"
                        :onClick (fn []
                                   (log/debug "bearbeiten geklickt " cell-data)
                                   (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data))
                        } [info {:fontSize "small"}]])))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn date-time-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(js/console.log l-date)
    (if (> (count cell-data) 10)
      (r/as-element [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4)) [:br] (str (subs cell-data 9 11) ":" (subs cell-data 11 13))])
      (r/as-element [:span "-"]))))






(defn select-renderer [!st ?ro]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/checkbox
         {:onChange (fn [_ val] (swap! !st assoc-in [:selected cell-data] val))
          :disabled ?ro
          :checked  (or (get-in @!st [:selected cell-data]) false)
          }
         ]))))

(defn inside-table [!st rows]
  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !search (r/cursor !st [:search])
          ro? false
          ]
      (log/debug "rerender " m " rows " (count rows) " @!sort " (clj->js @!st))
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 0)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "EventUserList"}


         [:> rv/Column
          {:label        (r/as-element [mui/checkbox {:disabled true}])
           :dataKey      (name :tomId)
           :className    "bordered exampleColumn"
           :cellRenderer (select-renderer !st ro?)
           :width        70} [:a {:href ""}]]

         [:> rv/Column
          {:label     "TomId"
           :dataKey   "tomId"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     70}]
         [:> rv/Column
          {:label     "Vorname"
           :dataKey   "firstName"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   "lastName"
           :className "bordered exampleColumn"
           :width     170}]



         [:> rv/Column
          {:label        (r/as-element [info])
           :dataKey      "tomId"
           :className    "bordered exampleColumn"
           :cellRenderer info-cell-renderer
           :width        70}]

         [:> rv/Column
          {:label     "Email"
           :dataKey   "email"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Handy"
           :dataKey   "phoneNumber"
           :className "bordered exampleColumn"
           :width     170}]

         ]))))





(defn filter-fn [rows search]
  (println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:tomId e) "#" (:firstName e) "#" (:lastName e) "#" (:email e) "#" (:phoneNumber e))))
          rows))

(defn get-sort-filter-rows [alarm type_ sort_ reverse_ filter_]
  (let [rows (if (= :alarmable type_)
               (:_eventAlarm-alarmable alarm)
               (:_eventAlarm-alarmed alarm))
        rows (filter-fn (into [] rows) filter_)
        rows (sort-by (keyword (if sort_ sort_ :lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    (js/console.log "get-sort-filter-rows = " (clj->js (:_eventAlarm-alarmable alarm)) (clj->js sort_) (count rows))
    rows))




(defn get-table [!st rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st rows)]))


(defn selected-actions [!eventAlarm !st {:keys [allow-alarm? allow-force-alarm?]} rows]
  (let [alarm-uuid (:eventAlarm-uuid @!eventAlarm)
        !show-force-alarm (r/cursor !st [:show-force-alarm-multi])
        !show-alarm (r/cursor !st [:show-alarm-multi])
        !show-select-first (r/cursor !st [:show-select-first])
        !st-selected (r/cursor !st [:selected])
        !st-selection-action (r/cursor !st [:selected-action])
        !show-message-sent (r/cursor !st [:activeMessageSent])
        !show-send-mail-multiple (r/cursor !st [:activeSendMailMultiple])
        !show-add-selected (r/cursor !st [:add-selected])
        update-fn (fn [] (reset! !st-selected {}) (d-eventAlarm/alarm-update))
        select-first-fn (fn [& [max]] (reset! !st-selected (reduce (fn [c {tomId :tomId}] (log/debug "select all + " tomId) (assoc c tomId true)) @!st-selected (take (or max 1000000) rows))))
        ]
    [:div
     [enter-amount-modal/modal !show-select-first (str "Ersten X Personen auswählen. Anzahl eingeben bitte:") "Auswählen"
      (fn [amount] (select-first-fn amount))]

     [are-you-sure-modal/are-you-sure-modal !show-alarm (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich alarmieren? Bereits angefragte werden ignoriert.") "anfragen"
      (fn [] (d-eventAlarm/>member-action alarm-uuid "alarm" @!st-selected #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-force-alarm (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer wirklich alarmieren? Bereits alarmierte werden NOCHMALS alarmiert.") "anfragen"
      (fn [] (d-eventAlarm/>member-action alarm-uuid "force-alarm" @!st-selected #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-add-selected (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer in die Auswahl übernehmen?") "übernehmen"
      (fn [] (a/add-to-selection (mapv first @!st-selected)))]

     [(send-message-modal/email-template-modal !show-send-mail-multiple "event" (str "Email erstellen und an " (when @!show-send-mail-multiple (count @!show-send-mail-multiple)) " Personen senden:") "senden"
                                               (fn [subject email from] (d-user/email-to-tomIds (mapv first @!show-send-mail-multiple) subject email from #(reset! !show-message-sent true)))
                                               nil
                                               (fn [subject email from] (d-user/email-to-tomIds (mapv first @!show-send-mail-multiple) subject email from #(reset! !show-message-sent true) :self))
                                               )]


     [mui/icon-button {:title   "Alle abwählen"
                       :onClick #(swap! !st assoc :selected {})
                       } [check-box-outline-blank {:fontSize "small"}]]
     [mui/icon-button {:title   "Alle wählen"
                       :onClick #(select-first-fn)
                       } [check-box {:fontSize "small"}]]


     [mui/icon-button {:title   "Ersten X wählen"
                       :style   {:marginRight "15px"}
                       :onClick #(reset! !show-select-first true)
                       } [add {:fontSize "small"}]]
     [mui/select
      {:style        {:width "300px"}
       :defaultValue "-"
       :onChange     (fn [e]
                       (let [[action uuid] (clojure.string/split (h/event-value e) #"#")]
                         (log/debug " st-selection-action" action uuid)
                         (reset! !st-selection-action action)))
       }
      [mui/menu-item {:value "-"} (str (count-true @!st-selected) " Auswahl")]
      (when allow-alarm? [mui/menu-item {:value "alarm"} "Jetzt anfragen"])
      (when allow-force-alarm? [mui/menu-item {:value "force-alarm"} "Jetzt (erneut) anfragen!"])
      [mui/menu-item {:value "mailTo"} [email {:style {:marginRight "4px"}}] "  `Email senden`"]
      [mui/menu-item {:value "select"} "`In Auswahl übernehmen`"]
      ]
     [mui/button {:disabled (if (or (nil? @!st-selection-action) (empty? @!st-selected) (= @!st-selection-action "-")) true false)
                  :onClick  (fn []
                              (log/debug "übernehmen clicked " @!st-selection-action @!st-selected)
                              (case @!st-selection-action
                                "alarm" (reset! !show-alarm true)
                                "force-alarm" (reset! !show-force-alarm true)

                                "mailTo" (reset! !show-send-mail-multiple @!st-selected)

                                "select" (reset! !show-add-selected @!st-selected)

                                :else nil))
                  } "übernehmen"]
     ]
    ))

(defn get-it []
  (let [!st (r/atom {:sort :lastName :reverse true :search "" :show-delete false :manipulate-tomId nil :show-mail false })

        ]
    (fn [!alarm !event-detail-loaded? type_ ro?]
      (let [
            !map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])

            !sort (r/cursor !st [:sort])
            !reverse (r/cursor !st [:reverse])
            !search (r/cursor !st [:search])
            !waiting? (r/cursor !st [:waiting])
            table_rows (get-sort-filter-rows @!alarm type_ @!sort @!reverse @!search)
            table-set {:allow-alarm? (if (= :alarmable type_) true false) :allow-force-alarm? true}

            ]
        (log/debug "Event ROWS !!!!!!!!!!!!!!!!!!!!!!" (name type_) (clj->js @!st))
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style      {:height "calc(100% - 64px)" :minHeight "600px"}
          }

         [toe-modal/get-modal !map-userPopup]
         [mui/grid
          {:item  true
           :md    6
           :xs    6
           :style {:textAlign "left"}}

          [selected-actions !alarm !st table-set table_rows !event-detail-loaded?]
          ]

         [mui/grid
          {:item  true
           :md    3
           :xs    3
           :style {:textAlign "left"}}
          [mui/text-field
           {:default-value (str @!search)
            :placeholder   "Suche in Liste ..."
            :style         {:width "250px" :display "inline-block"}
            :onChange      (h/wait-do !waiting? #(reset! !search %))
            :multiline     false}]
          (when false                                       ; (> (count @!search) 0)
            [mui/button {:variant   "outlined"
                         :startIcon (r/as-element [close])
                         :onClick   (h/wait-do !waiting? (fn [_] (reset! !search "")))
                         :style     {:margin-left "5px" :margin-right "25px"}} ""])
          ]

         [mui/grid
          {:item  true
           :lg    12
           :xs    12
           :style {:textAlign "left"}}

          [(get-table !st table_rows)]
          ]

         ]
        )
      )))
























